import React, { useState } from 'react';
import "./index.css";
import { Col, Row, Space } from 'antd';
import ErrorImage from '../../assets/images/ErrorImage.jpg';

class ErrorBoundary extends React.Component {
   
     onButtonClickHandler = () => {
    this.setState({ showMessage: !this.state.showMessage });
  };
   
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }   

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
        this.setState({ error: error, errorInfo: errorInfo });
    }

    render() {
    
        if (!this.state.hasError) return this.props.children;
        return (
          
            <div className="error-boundary-container" style={{alignItems:'center'}}>
                <Row  style={{alignItems:'center',margin:'auto',justifyContent:'center'}} gutter={20}>
                <Col span={8}>
                <img src={ErrorImage} alt="Logo" style={{ maxWidth: '100%' }} />
                </Col>
                <Col span={8}>
                <div className="error-info-container">  
                    <div className="label">Oops! Something went wrong!</div>
                    <p>We encountered an unexpected error, Try reloading the page.</p>
                    <div className="reload-button">
                        <Space>
                        <button className='logsBtn' onClick={this.onButtonClickHandler} >{this.state.showMessage ? "Hide Logs" : "Show Logs"}</button>
                        <button className='reloadBtn' onClick={() => window.location.reload()}>Click to Reload the page</button> 
                    </Space>
                    </div>
                    
                </div>
                </Col>
                </Row>
               
                    {this.state.showMessage &&  <div className="debug-console" >
                        <div className="error-info">
                            {this.state.error && this.state.error.toString()}
                        </div>
                        {/* <pre className="error-stack-trace">
                            {this.state.error && this.state.error.stack}
                        </pre> */}
                        <pre className="error-stack-trace">
                            {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </pre>
                    </div>  }
            </div>  
      
        )
    }

}


export default ErrorBoundary;

